import React, { FC, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import FormField from "../../../components/common/FormField";
import { accountInfoFields } from "./accountAllFields";

interface ManageAccountInfoProps {
  selectClient: any; // Adjust type as per your requirement
  userProfile: any;
  useDetails: any;
  setUserDetails: any;
  checkValidator?: any;
  resetValidator?: any;
  error?: any;
  setIsDisabled?: any;
  setCountryCode?: any;
  countryCode?: any;
}

const AccountInfoForm: FC<ManageAccountInfoProps> = ({
  selectClient,
  userProfile,
  useDetails,
  setUserDetails,
  checkValidator,
  resetValidator,
  error,
  setIsDisabled,
  setCountryCode,
  countryCode,
}) => {
  useEffect(() => {
    const fieldMapping: { [key: string]: string } = {
      firstName: "name",
      lastName: "last_name",
      email: "email",
      phone: "phoneNumber",
      userEmailSignature: "user_email_signature",
    };

    if (userProfile) {
      const initialValues = accountInfoFields.reduce(
        (acc, field) => {
          const profileKey = fieldMapping[field.id];
          
          if (field.id === "phone" && userProfile?.[profileKey]) {
            // Remove country code from phone number
            acc[field.id] = userProfile[profileKey].replace(/^\+91|\+44/, "") || "";
            const extractedCountryCode = userProfile[profileKey].match(/^\+91|\+44/);
            setCountryCode(extractedCountryCode ? extractedCountryCode[0] : "+44");
          } else if (profileKey) {
            // Map using the field mapping
            acc[field.id] = userProfile?.[profileKey] || "";
            
            // Debug logging for editor field
            if (field.id === "userEmailSignature") {
              console.log("AccountInfoFields - Mapping userEmailSignature");
              console.log("  profileKey:", profileKey);
              console.log("  userProfile value:", userProfile?.[profileKey]);
              console.log("  assigned value:", acc[field.id]);
            }
          }
          return acc;
        },
        {} as { [key: string]: any },
      );
      console.log("AccountInfoFields - Final initialValues:", initialValues);
      setUserDetails(initialValues);
    }
  }, [userProfile, setUserDetails, setCountryCode]);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    setUserDetails((prevValues: any) => ({
      ...prevValues,
      [id]: value,
    }));
    resetValidator(event.target.id);
    setIsDisabled(false);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
  return (
    <>
      {accountInfoFields.map((field, i) => {
        // Debug logging for editor field being rendered
        if (field.id === "userEmailSignature") {
          console.log("Rendering editor field");
          console.log("  field.id:", field.id);
          console.log("  useDetails:", useDetails);
          console.log("  useDetails[field.id]:", useDetails?.[field.id]);
        }
        return (
          !selectClient && (
            <Grid
              container
              spacing={2}
              key={i}
              style={{ marginLeft: "0px", width: "100%" }}
            >
              <FormField
                {...(field?.type !== "editor" && {
                  onPaste: (e: any) => e.preventDefault(),
                  onKeyDown: (event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return event;
                    if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.target.value + event.key)
                    ) {
                      event.preventDefault();
                    }
                  },
                })}
                {...{
                  ...field,
                  ...{
                    variant: "outlined",
                    inSingleGridForm: true,
                    isNonMarginTop: true,
                    onCountryCodeChange:
                      field.type === "contact" // Example of checking if it's a country code field
                        ? (code: string) => {
                            setCountryCode(code);
                            setIsDisabled(false);
                          }
                        : undefined, // or you could pass a default function if necessary
                    ...{
                      ...(field?.type === "contact" && {
                        countryCode: useDetails ? countryCode : undefined,
                      }),
                    },
                    onChange: onChangeAction,
                    onBlur: onBlurAction,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      ...(field?.id === "email" && { disabled: true }),
                      sx:
                        field?.type === "text" || field?.type === "number"
                          ? { height: "36px" }
                          : { padding: "10px 4px", height: "36px" },
                    },
                  },
                  error: error && error[field?.id],
                  value: useDetails ? useDetails[field?.id] : "",
                }}
              />
            </Grid>
          )
        );
      })}
    </>
  );
};

export default AccountInfoForm;
